import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { saveClientData, uploadClientData } from "./clientApis";
import { toast } from "react-toastify";

const uploadDocument = async (file, caseId) => {
  try {
    const loginData = secureLocalStorage.getItem("loginCredentials");
    const userId = loginData?.user?.id;
    const token = loginData?.token;

    if (!userId || !file || !caseId || !token) {
      throw new Error("User ID, case ID, file, and token are required");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", userId);
    formData.append("caseId", caseId);

    const response = await axios.post(
      `${process.env.REACT_APP_NODE_BASE_URL}/case-documents/upload-document`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",

        }
      }
    );

    const formDataPython = new FormData();

    formDataPython.append("file", file);
    formDataPython.append("user_id", userId);
    formDataPython.append("case_id", caseId);

    const resp = await uploadClientData(formDataPython);

    if(resp.status === "success") {
      let clientDataToSave = {
        id_no: resp?.data?.analysis?.id_no,
        case_id: caseId,
        upload_date: resp?.data?.analysis?.upload_date,
      };

    const res = await saveClientData(clientDataToSave);

    if(res.status === "success") {
      toast.success("Client data saved successfully:");
    }
  }

    return response.data;
  } catch (error) {
    console.error("Upload error:", error.response?.data || error.message);
    throw error;
  }
};

const getCaseDocuments = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_NODE_BASE_URL}/case-documents/get-case-documents/${id}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

const deleteCaseDocument = (documentId) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(
        `${process.env.REACT_APP_NODE_BASE_URL}/case-documents/delete-case-document/${documentId}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export { uploadDocument, getCaseDocuments, deleteCaseDocument };
